import styled from 'styled-components';
import { WIDTH_BREAKPOINT_MD } from '../../lib/constants';

export const PricingTableContent = styled.table`
	border-collapse: collapse;
	margin-top: 50px;
	table-layout: fixed;
	width: 100%;

	@media (max-width: ${WIDTH_BREAKPOINT_MD}) {
		display: none;
	}
`;

export const PricingTableThead = styled.thead`
	background-color: ${({ theme }) => theme.backgroundHeader};
	border: 1px solid ${({ theme }) => theme.backgroundBorder};
`;

export const PricingTableTbody = styled.tbody`
	border: 1px solid ${({ theme }) => theme.backgroundBorder};
`;

export const PricingTableTh = styled.th`
	border-bottom: 1px solid ${({ theme }) => theme.backgroundBorder};
	border-right: 1px solid ${({ theme }) => theme.backgroundBorder};
	border-top: 1px solid ${({ theme }) => theme.backgroundBorder};
	font-family: 'Lato', sans-serif;
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 0.08px;
	line-height: 10px;
`;

export const PricingTableColTitle = styled.p`
	margin: 10px 0 20px;
`;

export const PricingTableColText = styled.p`
	font-family: 'Lato', sans-serif;
	margin: 10px 0 5px;
`;

export const PricingTableColSubtext = styled.p`
	color: #7d929e;
	font-family: 'Titillium Web', sans-serif;
	font-size: 15px;
	font-weight: 400;
	line-height: 21px;
	margin: 7px 0;
`;

export const HeaderCol = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	min-height: 205px;
	padding: 20px 13px;
	text-align: center;
	width: 100%;
`;

export const HeaderColHeadline = styled.span`
	color: #ea5d5a;
	font-family: Titillium Web, sans-serif;
	font-size: 26px;
	font-weight: 600;
	line-height: 31px;
`;

export const HeaderColPrice = styled.span`
	color: #ffffff;
	font-family: Titillium Web, sans-serif;
	font-size: 20px;
	font-weight: 400;
	line-height: 31px;
	margin-top: 5px;
	white-space: pre-wrap;
`;

export const HeaderColDescription = styled.span`
	color: #7d929e;
	font-family: Titillium Web, sans-serif;
	font-size: 15px;
	font-weight: 400;
	line-height: 21px;
	margin-top: 2px;
	white-space: pre-wrap;
`;

export const HeaderColButton = styled.a`
	background-color: transparent;
	border: 2px solid #ffffff;
	border-radius: 30px;
	color: #ffffff;
	display: inline-block;
	font-family: Titillium Web, sans-serif;
	font-size: 15px;
	font-weight: 600;
	line-height: 22px;
	margin-top: auto;
	padding: 6px 30px;
	text-transform: uppercase;
	transition: all 0.2s;
	white-space: nowrap;
	width: fit-content;

	&:hover {
		background-color: hsla(0, 0%, 100%, 0.05);
	}

	&:active {
		background-color: hsla(0, 0%, 100%, 0.1);
	}
`;

export const HeaderRow = styled(PricingTableTh)`
	line-height: 17px;
	padding: 20px;

	&:first-child {
		max-width: 300px;
		text-align: left;
	}
`;

export const MobileTableList = styled.ul`
	align-items: stretch;
	display: none;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	margin-top: 50px;

	@media (max-width: ${WIDTH_BREAKPOINT_MD}) {
		display: flex;
	}
`;

export const MobileTableItem = styled.li`
	border: 1px solid ${({ theme }) => theme.backgroundBorder};
	display: flex;
	flex-direction: column;
	justify-content: end;
	margin: 10px;
	max-width: 400px;
	width: 100%;

	.active {
		color: white;
	}
`;

export const MobileTableHeaderCol = styled(HeaderCol)`
	background-color: ${({ theme }) => theme.backgroundHeader};
	min-height: 200px;
`;

export const MobileTableRow = styled.div`
	border-top: 1px solid ${({ theme }) => theme.backgroundBorder};
	color: #333d42;
	font-family: 'Titillium Web', sans-serif;
	font-size: 16px;
	font-weight: 600;
	line-height: 17px;
	padding: 14px 40px;
	text-align: center;
`;
